let state = {
  user: {},
  userPoints: {},
  userInfo: {},

  muteNotifications: false,
};

export default state;
